import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faFilePdf } from "@fortawesome/free-regular-svg-icons"

export const FilePdfRegular = (props) => {
  return <FontAwesomeIcon faIcon={faFilePdf} {...props} />
}
